/** 가로 스와이퍼 좌우 패딩 (홈 콘텐츠 영역 공통) */
export const SWIPER_HORIZONTAL_PADDING = '20px'

/** 가로 스와이퍼 inline style — 매 렌더마다 동일 참조 유지 */
export const SWIPER_HORIZONTAL_PADDING_STYLE = {
  paddingLeft: SWIPER_HORIZONTAL_PADDING,
  paddingRight: SWIPER_HORIZONTAL_PADDING,
} as const
